<template>
  <NavBar />
  <MDBContainer>
    <div
      class="d-flex justify-content-center align-items-center"
      style="height: 100vh"
    >
      Hello {{ user.email }}!
      <div v-for="team in teams" :key="team.id">
        {{ team.name }}
        <div v-for="hotline in team.hotlines" :key="hotline.id">
          {{ hotline.name }}
        </div>
      </div>
      <MDBTabs v-model="activeTabId1">
        <MDBTabsNav tabsClasses="mb-3">
          <MDBTabsItem v-for="team in teams" :key="team.id" :tabId="'ex1-' + team.id" :href="'#team-' + team.id">
            {{ team.name }}
          </MDBTabsItem>
        </MDBTabsNav>
        <MDBTabsContent>
          <MDBTabPane 
            v-for="team in teams"
            :key="team.id"
            :id="'team-' + team.id">
            <MDBCard class="mb-3">
              <MDBCardBody>
                <h5>{{ team.name }}</h5>
                <div v-for="hotline in team.hotlines" :key="hotline.id">
                  <MDBCard class="mb-2">
                    <MDBCardBody>
                      {{ hotline.name }}
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBTabPane>
        </MDBTabsContent>
      </MDBTabs>
    </div>
  </MDBContainer>
  <FooterElem />
</template>

<script>
import {
  MDBContainer,
  MDBTabs,
  MDBTabsNav,
  MDBTabsItem,
  MDBTabsContent,
  MDBTabPane,
  MDBCard,
  MDBCardBody,
} from "mdb-vue-ui-kit";
import NavBar from "@/components/NavBar.vue";
import FooterElem from "@/components/FooterElem.vue";
import axios from "axios";
import { auth0 } from "src/auth0.js";

export default {
  name: "HomePage",
  components: {
    MDBContainer,
    MDBTabs,
    MDBTabsNav,
    MDBTabsItem,
    MDBTabsContent,
    MDBCard,
    MDBCardBody,
    NavBar,
    FooterElem,
  },
  data() {
    return {
      token: "",
      teams: [],
    };
  },
  async mounted() {
    await this.cacheAccessToken();
    await this.fetchTeams();
  },
  methods: {
    async fetchTeams() {
      const token = await auth0.getAccessTokenSilently();
      axios
        .get("/api/v3/team", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.teams = response.data;
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
    async cacheAccessToken() {
      const token = await auth0.getAccessTokenSilently();
      localStorage.setItem("accessToken", token);
    },
  },
};
</script>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";

const { user } = useAuth0();
</script>

<style scoped></style>
